import { Box, type SxProps, type Theme } from "@mui/material";
import { BRAND_GRADIENT, BRAND_INITIAL } from "@/constants/branding";

interface BrandMarkProps {
  size?: number;
  fontSize?: number | string;
  borderRadius?: number | string;
  sx?: SxProps<Theme>;
}

/** Square logo tile with initial letter (JOIP brand). */
export default function BrandMark({
  size = 56,
  fontSize,
  borderRadius = 2,
  sx,
}: BrandMarkProps) {
  const computedFont = fontSize ?? Math.round(size * 0.43);
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius,
        background: BRAND_GRADIENT,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontWeight: 800,
        fontSize: computedFont,
        ...sx,
      }}
    >
      {BRAND_INITIAL}
    </Box>
  );
}
